import { Heart } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { ComingSoon } from '../components/ui/ComingSoon';

export function SavedPinsPage() {
  return (
    <>
      <PageHeader
        icon={Heart}
        title="Saved Pins"
        description="Your bookmarked pins, organized in folders."
      />
      <ComingSoon what="Saved Pins UI" />
    </>
  );
}
